import type { ReactElement } from "react";
import { IconButton } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { StyledWizardButtonsWrapper, StyledWizardFooter, StyledWizardFooterCounter } from "./styles";

const FIRST_PAGE = 1;

interface WizardFooterEventsProps {
    onNext?: () => void;
    onBack?: () => void;
}

export interface WizardFooterProps extends WizardFooterEventsProps {
    currentPage: number;
    pageCount: number;
    isNextDisabled?: boolean;
    isLoading?: boolean;
}

const WizardFooter = ({
    currentPage,
    pageCount,
    isNextDisabled,
    isLoading,
    onNext,
    onBack
}: WizardFooterProps): ReactElement => {
    return (
        <StyledWizardFooter>
            <StyledWizardFooterCounter>{currentPage}/{pageCount}</StyledWizardFooterCounter>
            <StyledWizardButtonsWrapper>
                {currentPage > FIRST_PAGE ? <IconButton
                        type="flat"
                        iconName="arrow-left"
                        onClick={onBack}
                    >
                        {translate("si.common.button.back")}
                    </IconButton> : null}

                <IconButton
                    type="primary"
                    iconName="arrow-right"
                    placement={"right"}
                    isDisabled={isNextDisabled}
                    onClick={onNext}
                    showLoaderIcon={false}
                    isLoading={isLoading}
                >
                    {translate("si.common.button.next")}
                </IconButton>
            </StyledWizardButtonsWrapper>
        </StyledWizardFooter>
    );
}

export default WizardFooter;